module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1CD2h"))).then(() => parcelRequire('ljYL6'));